import { Link } from "react-router-dom";
import { useState } from "react";
import { useCart } from "@/context/CartContext";
import { Minus, Plus, Trash2, ArrowLeft } from "lucide-react";

const PAYPAL_ME_USER = process.env.REACT_APP_PAYPAL_ME_USER;
const paypalMeUrl = (amount) =>
  `https://www.paypal.com/paypalme/${PAYPAL_ME_USER}/${amount}`;

const Cart = () => {
  const { items, updateQuantity, removeItem, subtotal } = useCart();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCheckout = () => {
    if (items.length === 0) return;
    setError("");
    setLoading(true);
    try {
      window.location.href = paypalMeUrl(subtotal);
    } catch (e) {
      setError("Could not open PayPal");
      setLoading(false);
    }
  };

  return (
    <div className="cart-page" data-testid="cart-page">
      <Link to="/#bikes" className="back-link" data-testid="cart-back-link">
        <ArrowLeft size={14} /> KEEP SHOPPING
      </Link>

      <header className="cart-head">
        <p className="eyebrow">/ YOUR CART</p>
        <h1>CHECKOUT.</h1>
      </header>

      {items.length === 0 ? (
        <div className="cart-empty" data-testid="cart-empty">
          <p>Your garage is empty.</p>
          <Link to="/#bikes" className="btn btn-primary">SHOP THE FLEET →</Link>
        </div>
      ) : (
        <div className="cart-grid">
          <div className="cart-items">
            {items.map((it) => (
              <div
                className="cart-item"
                key={`${it.product_id}-${it.color}`}
                data-testid={`cart-item-${it.product_id}-${it.color.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="cart-item-img">
                  <img src={it.image} alt={it.name} style={{ filter: it.filter }} />
                </div>
                <div className="cart-item-info">
                  <h4 data-testid="cart-item-name">{it.name}</h4>
                  <p className="cart-item-color">
                    <span className="dot" style={{ background: it.hex }} /> {it.color}
                  </p>
                  <p className="cart-item-price" data-testid="cart-item-price">€{it.price}</p>
                </div>
                <div className="cart-item-actions">
                  <div className="qty-control sm">
                    <button
                      onClick={() => updateQuantity(it.product_id, it.color, it.quantity - 1)}
                      data-testid="cart-qty-dec"
                      aria-label="Decrease"
                    >
                      <Minus size={12} />
                    </button>
                    <span>{it.quantity}</span>
                    <button
                      onClick={() => updateQuantity(it.product_id, it.color, it.quantity + 1)}
                      data-testid="cart-qty-inc"
                      aria-label="Increase"
                    >
                      <Plus size={12} />
                    </button>
                  </div>
                  <button
                    className="icon-btn"
                    onClick={() => removeItem(it.product_id, it.color)}
                    data-testid="cart-remove"
                    aria-label="Remove"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
                <div className="cart-item-total" data-testid="cart-item-total">
                  €{it.price * it.quantity}
                </div>
              </div>
            ))}
          </div>

          <aside className="cart-summary" data-testid="cart-summary">
            <h3>ORDER SUMMARY</h3>
            <div className="summary-row">
              <span>Subtotal</span>
              <span data-testid="cart-subtotal">€{subtotal}</span>
            </div>
            <div className="summary-row muted">
              <span>Shipping</span>
              <span>Calculated at next step</span>
            </div>
            <div className="summary-divider" />
            <div className="summary-row total">
              <span>Total</span>
              <span data-testid="cart-total">€{subtotal}</span>
            </div>
            {error && <p className="error-msg" data-testid="checkout-error">{error}</p>}
            <button
              className="btn btn-primary btn-lg full"
              onClick={handleCheckout}
              disabled={loading}
              data-testid="checkout-btn"
            >
              {loading ? "REDIRECTING…" : "PAY WITH PAYPAL →"}
            </button>
            <p className="summary-fine">Secure payment powered by PayPal.</p>
          </aside>
        </div>
      )}
    </div>
  );
};

export default Cart;
